import * as yup from 'yup';

export const industryValidationSchema = yup.object({
  name: yup
    .string()
    .required('Industry name is required')
    .min(2, 'Industry name must be at least 2 characters')
    .max(100, 'Industry name must not exceed 100 characters'),
  description: yup
    .string()
    .max(500, 'Description must not exceed 500 characters')
    .nullable(),
  order: yup
    .number()
    .typeError('Order must be a number')
    .integer('Order must be an integer')
    .min(0, 'Order must be a positive number')
    .default(0),
  is_active: yup
    .boolean()
    .default(true),
  color: yup
    .string()
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Color must be a valid hex code')
    .nullable(),
  iconFile: yup
    .mixed()
    .test('fileSize', 'File size must be less than 2MB', (value) => {
      if (!value) return true;
      return value.size <= 2 * 1024 * 1024;
    })
    .test('fileType', 'Unsupported file format', (value) => {
      if (!value) return true;
      return ['image/jpeg', 'image/png', 'image/svg+xml'].includes(value.type);
    })
    .nullable(),
});

export const industryFeatureValidationSchema = yup.object({
  title: yup
    .string()
    .required('Feature title is required')
    .min(2, 'Feature title must be at least 2 characters')
    .max(100, 'Feature title must not exceed 100 characters'),
  description: yup
    .string()
    .max(500, 'Description must not exceed 500 characters')
    .nullable(),
  field_type: yup
    .string()
    .oneOf(['dropdown', 'radio', 'checkbox', 'number', 'text'], 'Invalid field type')
    .required('Field type is required'),
  is_required: yup
    .boolean()
    .default(false),
  order: yup
    .number()
    .typeError('Order must be a number')
    .integer('Order must be an integer')
    .min(0, 'Order must be a positive number')
    .default(0),
  is_active: yup
    .boolean()
    .default(true),
});

export const featureOptionValidationSchema = yup.object({
  label: yup
    .string()
    .required('Option label is required')
    .min(1, 'Option label must be at least 1 character')
    .max(100, 'Option label must not exceed 100 characters'),
  value: yup
    .string()
    .required('Option value is required')
    .min(1, 'Option value must be at least 1 character')
    .max(100, 'Option value must not exceed 100 characters'),
  price: yup
    .number()
    .typeError('Price must be a number')
    .min(0, 'Price must be a positive number')
    .default(0),
  price_type: yup
    .string()
    .oneOf(['fixed', 'percentage'], 'Price type must be fixed or percentage')
    .default('fixed'),
  is_default: yup
    .boolean()
    .default(false),
  order: yup
    .number()
    .typeError('Order must be a number')
    .integer('Order must be an integer')
    .min(0, 'Order must be a positive number')
    .default(0),
  is_active: yup
    .boolean()
    .default(true),
});
